import { isBrowser } from '@polestar/component-warehouse-react/helpers/supports';
export const fullscreenElementSupport = isBrowser &&
    !!(document.fullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.msFullscreenEnabled ||
        document.webkitSupportsFullscreen ||
        document.webkitFullscreenEnabled);
export const openFullscreen = (element) => {
    var _a, _b, _c, _d;
    // if triggered from the outside (make parent fullscreen for example), prevent forcing a requestFullscreen
    // when already in fullscreen mode which will trigger unnecessary errors (in Sentry)
    if (!isInFullscreen()) {
        if ((_a = element === null || element === void 0 ? void 0 : element.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen) {
            element.current.requestFullscreen();
        }
        else if ((_b = element === null || element === void 0 ? void 0 : element.current) === null || _b === void 0 ? void 0 : _b.mozRequestFullScreen) {
            element.current.mozRequestFullScreen();
        }
        else if ((_c = element === null || element === void 0 ? void 0 : element.current) === null || _c === void 0 ? void 0 : _c.webkitRequestFullscreen) {
            element.current.webkitRequestFullscreen();
        }
        else if ((_d = element === null || element === void 0 ? void 0 : element.current) === null || _d === void 0 ? void 0 : _d.webkitEnterFullscreen) {
            element.current.webkitEnterFullscreen();
        }
    }
};
export const closeFullscreen = () => {
    if (isInFullscreen()) {
        if (document === null || document === void 0 ? void 0 : document.exitFullscreen) {
            document.exitFullscreen();
        }
        else if (document === null || document === void 0 ? void 0 : document.mozExitFullScreen) {
            document.mozExitFullScreen();
        }
        else if (document === null || document === void 0 ? void 0 : document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    }
};
export const isInFullscreen = () => {
    return (isBrowser &&
        (!!document.fullscreenElement ||
            !!document.msFullscreenElement ||
            !!document.mozFullScreenElement ||
            !!document.webkitFullscreenElement ||
            false));
};
